import { useMediaQuery } from '@mui/material';

export const useIsMobile = () => {
  // This will return true if the screen width is less than or equal to 600px
  const isMobile = useMediaQuery('(max-width:600px)');

  return { isMobile };
};
